__turbopack_context__.v({
  "addButton": "InscriptionActionBuy-module__guEbOq__addButton",
  "addButtonCollapsed": "InscriptionActionBuy-module__guEbOq__addButtonCollapsed",
  "addButtonLabel": "InscriptionActionBuy-module__guEbOq__addButtonLabel",
  "buyButton": "InscriptionActionBuy-module__guEbOq__buyButton",
  "cardActions": "InscriptionActionBuy-module__guEbOq__cardActions",
  "cardButton": "InscriptionActionBuy-module__guEbOq__cardButton",
  "content": "InscriptionActionBuy-module__guEbOq__content",
  "icon": "InscriptionActionBuy-module__guEbOq__icon",
  "loading": "InscriptionActionBuy-module__guEbOq__loading",
  "measureButton": "InscriptionActionBuy-module__guEbOq__measureButton",
  "offerButton": "InscriptionActionBuy-module__guEbOq__offerButton",
  "offerIcon": "InscriptionActionBuy-module__guEbOq__offerIcon",
  "offerLong": "InscriptionActionBuy-module__guEbOq__offerLong",
  "offerShort": "InscriptionActionBuy-module__guEbOq__offerShort",
  "priceBlock": "InscriptionActionBuy-module__guEbOq__priceBlock",
  "priceContainer": "InscriptionActionBuy-module__guEbOq__priceContainer",
  "priceIcon": "InscriptionActionBuy-module__guEbOq__priceIcon",
  "priceLine": "InscriptionActionBuy-module__guEbOq__priceLine",
  "priceValue": "InscriptionActionBuy-module__guEbOq__priceValue",
  "root": "InscriptionActionBuy-module__guEbOq__root",
  "row": "InscriptionActionBuy-module__guEbOq__row",
  "selectedBuy": "InscriptionActionBuy-module__guEbOq__selectedBuy",
  "stackedRow": "InscriptionActionBuy-module__guEbOq__stackedRow",
});
